// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as TbAtoms from "./TbAtoms.bs.js";

function TbBranding(Props) {
  var match = Jotai.useAtom(TbAtoms.compactMode);
  var compactMode = match[0];
  return React.createElement("g", {
              className: "font-medium font-montserrat " + (
                compactMode ? "text-[15px]" : "text-[17px]"
              )
            }, React.createElement("text", {
                  fill: "var(--white1)",
                  textAnchor: "middle",
                  transform: "translate(32, " + (
                    compactMode ? "153" : "163"
                  ) + ")rotate(-90)"
                }, "tactics.tools"), React.createElement("text", {
                  fill: "var(--white1)",
                  textAnchor: "middle",
                  transform: "translate(723, " + (
                    compactMode ? "236" : "260"
                  ) + ")rotate(90)"
                }, "tactics.tools"), React.createElement("text", {
                  fill: "var(--white1)",
                  textAnchor: "middle",
                  transform: "translate(32, " + (
                    compactMode ? "504" : "565"
                  ) + ")rotate(-90)"
                }, "tactics.tools"), React.createElement("text", {
                  fill: "var(--white1)",
                  textAnchor: "middle",
                  transform: "translate(723, " + (
                    compactMode ? "588" : "657"
                  ) + ")rotate(90)"
                }, "tactics.tools"));
}

var make = TbBranding;

export {
  make ,
  
}
/* jotai Not a pure module */
